import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { MenubarModule } from 'primeng/menubar';
import { CartComponent } from '../../cart/cart/cart.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [MenubarModule, CartComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  items: MenuItem[] = [];

  title = '';
  baseHref = document.getElementsByTagName('base')[0].getAttribute('href');
  languagePrefix = this.baseHref?.replaceAll('/', '') || 'es';
  currentPath = window.location.pathname
    .replace('/es/', '')
    .replace('/en/', '');

  ngOnInit() {
    this.items = [
      {
        label: $localize`:@@header.menu.home.label:Inicio`,
        // routerLink: '/coches',
        url: `${this.baseHref}` + $localize`:@@header.menu.home.path:home`,
        target: '_self',
        styleClass: ['', 'inicio', 'home'].includes(this.currentPath)
          ? 'active'
          : '',
      },
      {
        label: $localize`:@@header.menu.contact.label:Contacto`,
        routerLink: '/contacto',
      },
      {
        label: $localize`:@@header.menu.contact.label:Pedido`,
        routerLink: '/pedido',
      },
      this.languagePrefix == 'es'
        ? {
            // label: 'Inglés',
            label:
              '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-uk">',
            styleClass: 'flag-menu',
            url: '/en/',
            target: '_self',
          }
        : {
            // label: 'Inglés',
            label:
              '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-es">',
            styleClass: 'flag-menu',
            url: '/es/',
            target: '_self',
          },
      // {
      //   label: `<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-${this.languagePrefix}">`,
      //   // label: `Idioma`,
      //   icon: 'pi pi-search',
      //   items: [
      //     this.languagePrefix == 'en'
      //       ? {
      //           // label: 'Inglés',
      //           label:
      //             '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-es">',
      //           styleClass: 'flag-menu',
      //           url: '/en/',
      //           target: '_self',
      //         }
      //       : {
      //           // label: 'Inglés',
      //           label:
      //             '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-uk">',
      //           styleClass: 'flag-menu',
      //           url: '/en/',
      //           target: '_self',
      //         },
      //   ],
      // },
      // {
      //   // label: 'Inglés',
      //   label:
      //     '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-es">',
      //   styleClass: '',
      //   url: '/en/',
      //   target: '_self',
      // },
      // {
      //   label: `<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-${this.languagePrefix}">`,

      //   styleClass: '',
      //   url: this.languagePrefix,
      //   target: '_self',
      // },
    ];
  }
}
